import is from '@sindresorhus/is';
import { useNavigate } from 'react-router';

import { sidebar } from '../../company-settings/constants';
import {
    buildJobArchitectureSettingsUrl,
    companySettingsRoute,
    type JobArchitectureSettingsOptions,
} from '../../company-settings/route-config';
import { useActiveJobArchitectureId } from '../url-navigation/job-architecture-scope';

export const useNavigateToSettings = (): {
    readonly navigateToSettings: (options?: JobArchitectureSettingsOptions) => void;
} => {
    const jobArchitectureId = useActiveJobArchitectureId();
    const navigate = useNavigate();

    const navigateToSettings = (options?: JobArchitectureSettingsOptions): void => {
        const mergedOptions: JobArchitectureSettingsOptions = is.undefined(options)
            ? { sidebar: sidebar.jobArchitecture.companyProfile }
            : { sidebar: sidebar.jobArchitecture.companyProfile, ...options };

        const baseUrl = buildJobArchitectureSettingsUrl(jobArchitectureId, mergedOptions);
        const currentPath = window.location.pathname + window.location.search;

        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.set(companySettingsRoute.searchParams.returnUrl, currentPath);

        navigate(url.pathname + url.search);
    };

    return { navigateToSettings };
};
